import React from 'react'
import { useTranslation } from 'react-i18next'
import {Form, Input} from 'antd'

import {CODE_INPUT} from '@/constants/playwright-ids'

type FormItemVerificationCodeProps = {
    length?: number
    className?: string
}

export const FormItemVerificationCode: React.FC<FormItemVerificationCodeProps> = ({
    length = 6,
    className
}) => {
    const { t } = useTranslation()
    return (
        <Form.Item
            name='verificationCode'
            className={className}
            rules={[
                {
                    required: true,
                    message: t('FormItemVerificationCode.errors.codeRequired')
                },

                {
                    validator: async (_, value) => {
                        if (value && value.length !== length)
                            throw new Error(t('FormItemVerificationCode.errors.codeInvalid'))
                    }
                }
            ]}
        >
            <Input
                placeholder={t('FormItemVerificationCode.codePlaceholder')}
                maxLength={length}
                data-test-id={CODE_INPUT}
            />
        </Form.Item>
    )
}
